import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { jwtDecode } from "jwt-decode";
import authApiService from "../../services/authServices";
import { ThreeDots } from "react-loader-spinner";

const formatDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString();
};

const ClearSeasonList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isAdmin = useMemo(() => {
    try {
      const t = localStorage.getItem("accessToken");
      if (!t) return false;
      const d = jwtDecode(t);
      return Number(d?.role) === 1;
    } catch {
      return false;
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) {
      setLoading(false);
      return;
    }
    const load = async () => {
      setError(null);
      setLoading(true);
      try {
        const res = await authApiService.get("deletedSeasonsList");
        if (res?.code === 403) {
          setError("Admin access required.");
          setRows([]);
          return;
        }
        const list = res?.data?.deletedSeasons ?? res?.data ?? [];
        setRows(Array.isArray(list) ? list : []);
      } catch (e) {
        console.error(e);
        setError(e.response?.data?.message || "Failed to load deleted seasons.");
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [isAdmin]);

  const columns = useMemo(
    () => [
      { name: "Registration / Event", selector: (r) => r.name, sortable: true, grow: 1 },
      { name: "Season name", selector: (r) => r.seasonName || "—", sortable: true },
      { name: "City", selector: (r) => r.cityName || r.cityId, sortable: true },
      { name: "Start", selector: (r) => formatDate(r.start), sortable: true },
      { name: "End", selector: (r) => formatDate(r.end), sortable: true },
    ],
    []
  );

  if (!isAdmin) {
    return (
      <div className="page-container col-sm-9">
        <p className="mt-4">You do not have access to this page.</p>
        <button type="button" className="btn btn-link" onClick={() => navigate("/carter/home")}>
          Home
        </button>
      </div>
    );
  }

  return (
    <div className="page-container col-sm-9">
      <h2 className="page-title mb-3">Clear Season List</h2>
      <p className="text-muted small mb-3">
        Registrations that were removed from Manage Seasons (soft-deleted). Admin only.
      </p>
      {error && <div className="alert alert-warning">{error}</div>}
      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <ThreeDots height="60" width="60" color="#4fa94d" visible ariaLabel="loading" />
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={rows}
          pagination
          paginationPerPage={15}
          dense
          highlightOnHover
          noDataComponent={<div className="p-4">No deleted seasons found.</div>}
        />
      )}
    </div>
  );
};

export default ClearSeasonList;
